<script>
import BaseInputDeadline from "@/components/BaseInputDeadline";
import BaseReportTable from '../../../../components/BaseReportTable';
import Multiselect from 'vue-multiselect'
import Moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import {required, email} from "vuelidate/lib/validators";
import notification from "@/plugins/vue-notification-config";
import {queryToString} from "@/utils/helperFunction";
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'
import {mapGetters} from "vuex";


export default {
	name: "userDailyTasks",
	components: {
		vSelect,
		BaseReportTable,
		BaseInputDeadline,
		Datepicker,
		Multiselect,
	},
	data: () => ({
		params: {
			companyIds: [],
			departmentIds: [],
			officeIds: [],
			managerId: null,
			projectIds: [],
			userId: null
		},
		companies: [],
		offices: [],
		departments: [],
		tableData: [],
		projectSelectionList: [],
		selectedProjects: [],
		status: 1,
		filterDate: new Date(),
		managerList: [],
		usersList: [],
		managerId: null,
		emailAddress: '',
		subject: '',
	}),
	computed: {
		statusList() {
			let staticStatus = [
				{
					text: this.$t('DOING'),
					value: 1
				},
				{value: "0", text: this.$t('DONE')},
				{value: "2", text: this.$t('VERIFY')},
				{value: "3", text: this.$t('ARCHIVE')},
				{value: "5", text: this.$t('ACTIVE')},
			]

			if (this.isAdmin || this.isTeamLeader) {
				staticStatus = staticStatus.concat([
					{value: "4", text: this.$t('NOTASKS')},
					{value: "6", text: this.$t('ALL')},
				])
			}

			return staticStatus
		},
		disableDatePicker() {
			let today = Moment().format('DD-MM-YY');
			let date = Moment(this.filterDate).format('DD-MM-YY');
			return today == date;
		},
		userProfiles() {
			return this.$store.state.userProfile
		},
		...mapGetters([
			'isAdmin',
			'isTeamLeader',
			"userProfile"
		]),
		isEmployee() {
			return !this.isAdmin && !this.isTeamLeader
		}
	},
	watch: {
		'status': function (val) {
			this.changedFilter();
		},
		'filterDate': function (val) {
			this.changedFilter();
		},
		userProfile: {
			immediate: true,
			handler() {
				this.init()
			}
		}
	},
	methods: {
		async init() {
			if (this.userProfile.id) {
				this.$store.state.loader = true;
				if (this.isEmployee) this.params.userId = this.userProfile.id
				if (this.isTeamLeader) this.params.managerId = this.userProfile.id
				await this.GetProjectSelectionAll();
				await this.getTableData();
				this.$store.state.loader = false;
				if (this.isAdmin || this.isTeamLeader) {
					await this.getUsers()
				}
				if (this.isAdmin) {
					await this.getManagerAll();
					// await this.getCompanies()
					// await this.getOffices()
					// await this.getDepartments()
				}
			}
		},
		async getCompanies() {
			try {
				const {data: {data}} = await this.$api.get('companies')
				this.companies = data
			} catch (e) {
				notification.error()
			}
		},
		async getOffices() {
			try {
				const {data: {data}} = await this.$api.get('offices')
				this.offices = data
			} catch (e) {
				notification.error(e)
			}
		},
		async getDepartments() {
			try {
				const {data: {data}} = await this.$api.get('departments')
				this.departments = data
			} catch (e) {
				notification.error(e)
			}
		},
		async getUsers() {
			let params = {
				isGroupMembers: this.isTeamLeader
			}
			await this.$api.get('employees', {params})
				.then((res => {
					this.usersList = res.data.data
				}))
		},
		async getManagerAll() {
			await this.$api.get('employees', {
				params: {
					isTeamLeader: true
				}
			})
				.then(res => {
					this.managerList = res.data.data
				})

		},
		async GetProjectSelectionAll() {
			await this.$api
				.get('projects/projects')
				.then(response => {
					this.projectSelectionList = response.data.data;
				});
		},
		async getTableData() {
			const queryParams = queryToString(this.params)
			try {
				const res = await this.$api.get('report/status/task/details' + queryParams, {
					params: {
						taskStatus: this.status,
						taskDate: this.filterDate ? Moment(this.filterDate).format('YYYY-MM-DD') : Moment(+new Date()).format('YYYY-MM-DD'),
					}
				});
				this.tableData = res.data.data;
			} catch (e) {
				console.log(e)
			}
		},
		getManagerOptionLabel({firstName, lastName, middleName}) {
			if (firstName || lastName || middleName) return `${lastName} ${firstName} ${middleName}`
			return ''
		},
		getUsersOptionLabel({fullName}) {
			return `${fullName}`
		},
		async changedFilter() {
			this.$store.state.loader = true;
			await this.getTableData();
			this.$store.state.loader = false;
		},
		checkTaskText(text) {
			if (text) {
				return text == 'Oxirgi task stop qilinmagan';
			}
		},
		ExportToFile() {
			this.$store.state.loader = true;
			const queryParams = queryToString(this.params)
			this.$api
				.get('file/report/daily/upload' + queryParams, {
					params: {
						taskStatus: this.status,
						taskDate: this.filterDate ? Moment(this.filterDate).format('YYYY-MM-DD') : Moment(+new Date()).format('YYYY-MM-DD'),
					},
					responseType: 'blob',
				})
				.then(response => {
					const a = document.createElement("a");
					a.style.display = "none";
					document.body.appendChild(a);

					// Set the HREF to a Blob representation of the data to be downloaded
					a.setAttribute("href", window.URL.createObjectURL(new Blob([response.data])));

					// Use download attribute to set set desired file name
					a.setAttribute("download", 'exported.xlsx');

					a.click();

					// Cleanup
					document.body.removeChild(a);
				});
			this.$store.state.loader = false;
		},
		async sendDailyReport() {
			let projectIds = [];
			if (this.selectedProjects.length > 0) {
				this.selectedProjects.map(project => (
					projectIds.push(project.id)
				));
			}
			this.$v.$touch();
			if (!this.$v.$invalid) {
				const queryParams = queryToString(this.params)
				await this.$api.get('send/daily/report' + queryParams, {
					params: {
						subject: this.subject,
						sendTo: this.emailAddress,
						taskDate: this.filterDate ? Moment(this.filterDate).format('YYYY-MM-DD') : Moment(+new Date()).format('YYYY-MM-DD'),
						taskStatus: this.status,
					}
				})
					.then(res => {
						if (res.status === 200) {
							this.$notification.success(this.$t('SuccessfullySent'));
							this.emailAddress = '';
							this.subject = '';
							this.$v.$reset();
						}
					})
			}
		},
		async prevDay() {
			this.filterDate = Moment(this.filterDate).subtract(1, 'days')._d
		},
		async nextDay() {
			this.filterDate = Moment(this.filterDate).add(1, 'days')._d
		}
	},
	validations: {
		emailAddress: {
			required, email
		},
		subject: {
			required
		}
	},
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>


.az_report_nav_it {
	width: 210px;
}

.vs__dropdown-toggle {
	min-height: 42px;
	background: #fbfbff;
	border: 1px solid #e3e7f3;
}


</style>
<template src="./template.html"></template>
